import type { SVGProps } from 'react'

export const HistoryIcon: { __brand: 'color' | 'nocolor' } = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M2.49463 10.8081C3.06613 12.8751 4.61413 14.6263 6.79438 15.3778C10.3194 16.5958 14.1602 14.7238 15.3707 11.1988C16.5879 7.68135 14.7167 3.83986 11.1992 2.62261C8.31766 1.62788 5.24036 2.69047 3.53562 5.02827"
        stroke="var(--color-icon-base-default, #707070)"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M2.93701 3.20312V5.67737H5.39776"
        stroke="var(--color-icon-base-default, #707070)"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M6.73828 10.9269L9.1188 9.50415V6.43066"
        stroke="var(--color-icon-base-default, #707070)"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  )
}

HistoryIcon.__brand = 'nocolor'
